var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoastLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    role: "img",
    "aria-hidden": "true",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.25 0h373.5A63.25 63.25 0 0 1 500 63.25V500H63.25A63.25 63.25 0 0 1 0 436.75V63.25A63.25 63.25 0 0 1 63.25 0z",
    fill: "#a4286a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M500 63.25A63.24 63.24 0 0 0 436.87 0L154.26 500H500z",
    fill: "#6c2548"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4 335.2v34.9c21.6-.9 38.5-8 52.8-22.5s27.4-38 39.9-72.9l92.6-248h-44.8l-74.6 207.2-37-116.2h-41l54.4 139.8a57.54 57.54 0 0 1 0 41.8c-5.5 14.2-15.4 30.9-42.3 35.9z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M416.2 35.9l-95.8 169.5a97.35 97.35 0 0 0 95.8-169.5z",
    fill: "#77b227"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M283.5 72.8a97.31 97.31 0 0 0 36.86 132.58L416.2 35.9a97.3 97.3 0 0 0-132.61 36.74z",
    fill: "#9fda4f"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M294.5 250.5l-62.6 110.8a63.63 63.63 0 1 0 62.6-110.8z",
    fill: "#f49a00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M294.7 250.7A63.61 63.61 0 0 0 232 361.4z",
    fill: "#fec228"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M202.9 412.7l-37.6 66.5a38.2 38.2 0 0 0 37.5-66.5z",
    fill: "#ed261f"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M202.9 412.8a38.2 38.2 0 0 0-40.9 64.54c1.06.67 2.16 1.29 3.28 1.86z",
    fill: "#ff4e47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoastLogo);
export default __webpack_public_path__ + "static/media/yoast-logo.d226f442a3af7dc22cebe1c0575ebd83.svg";
export { ForwardRef as ReactComponent };